import React, { useContext } from 'react'
import { ApiGetCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { formatDateToMMDDYYYY } from '../../JS/Common';
import GreyBoxForReports from './GreyBoxForReports';
import { log } from '../../JS/Logger';
import useConfig from '../../Hooks/useConfig';

export default function MassUsers({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    const { organization, show_purchase_map_csv_header, purchase_map_csv_header } = useConfig();
    async function GetUserData() {
        setLoading(true);
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        await ApiGetCall(`/reports/student-details?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&flag=${downloadall}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length > 0) {
                    DownloadCsv(responseRs);
                } else {
                    DownloadCsv([]);
                    setalerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
                    setTimeout(() => {
                        setalerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
            setLoading(false);
        });
    }
    const DownloadCsv = (CsvData) => {
        const csvContent = [];
        const PurchaseMap = [];
        CsvData?.forEach((item) => {
            const plansFormatted = item.plans?.length > 0 ?
                item.plans?.map(planItem => planItem.plan).join(', ') : '-';
            const rowData = {
                [`${organization} Name`]: item.school,
                'Total Users': item.total_users,
            };
            if (show_purchase_map_csv_header) {
                rowData[purchase_map_csv_header] = plansFormatted;
            }
            PurchaseMap.push(rowData);
        });

        if (PurchaseMap.length > 0) {
            const headers = [`${organization} Name`, 'Total Users', purchase_map_csv_header];
            csvContent.push(headers);
            PurchaseMap.forEach((rowData) => {
                const values = Object.values(rowData).map(value => {
                    if (typeof value == 'string' && value.includes(',')) {
                        return `"${value}"`;
                    }
                    return value;
                });
                csvContent.push(values);
            });
            csvContent.push([]);
            const csvString = csvContent.map((row) => row.join(',')).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'BulkUsers.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            log.error('No data available for download.');
        }
    };
    return (
        <GreyBoxForReports icon="faUsers" name={"Bulk Users Report Download"} onclickfunc={GetUserData} />
    )
}
